import { Container, Graphics, Text } from 'pixi.js';
import { WORLD_W, WORLD_H, palette } from '../render/theme.js';

export class GameOverScreen {
  readonly container: Container;
  private scoreText: Text;
  private onRestart: (() => void) | null = null;

  constructor() {
    this.container = new Container();
    this.scoreText = new Text({ text: '', style: { fill: 0xffffff, fontSize: 20, fontFamily: 'monospace' } });
    this.build();
  }

  private build(): void {
    const c = this.container;

    const bg = new Graphics();
    bg.rect(0, 0, WORLD_W, WORLD_H).fill({ color: 0x050810, alpha: 0.92 });
    c.addChild(bg);

    const title = new Text({
      text: 'GAME OVER',
      style: {
        fill: 0xff4444,
        fontSize: 48,
        fontFamily: 'monospace',
        fontWeight: 'bold',
        letterSpacing: 4,
      },
    });
    title.anchor.set(0.5, 0.5);
    title.x = WORLD_W / 2;
    title.y = WORLD_H * 0.35;
    c.addChild(title);

    this.scoreText.anchor.set(0.5, 0.5);
    this.scoreText.x = WORLD_W / 2;
    this.scoreText.y = WORLD_H * 0.48;
    c.addChild(this.scoreText);

    const tap = new Text({
      text: 'TAP TO RESTART',
      style: {
        fill: palette.hud,
        fontSize: 18,
        fontFamily: 'monospace',
        letterSpacing: 3,
      },
    });
    tap.anchor.set(0.5, 0.5);
    tap.x = WORLD_W / 2;
    tap.y = WORLD_H * 0.62;
    c.addChild(tap);

    this.container.interactive = true;
    this.container.hitArea = { contains: () => true } as unknown as import('pixi.js').Rectangle;
    this.container.on('pointerdown', () => {
      this.onRestart?.();
    });
  }

  show(score: number, hiScore: number): void {
    this.scoreText.text = `SCORE  ${score}\nBEST   ${hiScore}`;
    this.container.visible = true;
  }

  onRestartGame(cb: () => void): void {
    this.onRestart = cb;
  }

  update(_dtMs: number): void {
    const tap = this.container.children[3] as Text | undefined;
    if (tap) {
      tap.alpha = 0.5 + 0.5 * Math.sin(performance.now() / 500);
    }
  }
}
